import { render, staticRenderFns } from "./LinkWithTextEl.vue?vue&type=template&id=20b2d75a&scoped=true&"
import script from "./LinkWithTextEl.vue?vue&type=script&lang=ts&"
export * from "./LinkWithTextEl.vue?vue&type=script&lang=ts&"
import style0 from "./LinkWithTextEl.vue?vue&type=style&index=0&id=20b2d75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b2d75a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
